import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {
    CartDto,
    CartItemDto,
    HttpRequestDto,
    HttpResponseDto,
    ProductDto,
    QuotationControllerService,
    RfqLookupDto,
    RfqProductRequestDto,
    SelectOption
} from '../../@api';
import {DOCUMENT} from '@angular/common';
import {BrowserStorageService} from '../../service/browser.storage.service';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {FormGroup, NgForm} from '@angular/forms';
import {Message} from 'primeng/api';
import {environment} from '../../../environments/environment';
import {AbstractQuote} from './abstract-quote';
import {Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';

@Component({
    selector: 'quote',
    templateUrl: './quote.component.html',
    styleUrls: ['./quote.component.scss']
})
export class QuoteComponent extends AbstractQuote implements OnInit {

    @Input('product') product: ProductDto;
    @ViewChild('quoteForm') quoteForm: NgForm;

    provinces: SelectOption[] = [];

    formSubmitted: boolean;
    quoteReceived: boolean;
    reCAPTCHA: boolean;

    errors: Message[] = [{severity: 'error', detail: 'Please correct errors on the mandatory fields.'}];
    uuid: string;

    constructor(@Inject(DOCUMENT) public override document: Document,
                protected override state: StatePersistenceService,
                protected override browser: BrowserStorageService,
                protected override router: Router,
                protected override breadcrumbService: BreadcrumbService,
                private quotationService: QuotationControllerService) {
        super(document, state, browser, router, breadcrumbService);
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.quotationService.findRfqLookupData().subscribe((response: RfqLookupDto): void => {
            this.provinces = response.provinces;
        }, error => {
            console.log(error);
        });
    }

    remove(item: CartItemDto): void {
        let cart: CartDto = this.state.quoteComponent.data;
        let expiryDate: Date = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        cart.expiryDate = expiryDate;

        cart.items.splice(cart.items.indexOf(item), 1);
        this.browser.setLocalStorageValue('$q', cart);
    }

    ngModelChanged($event: any): void { }

    resetForm(): void {
        let cart: CartDto = this.state.quoteComponent.data;
        cart.items = [];
        let expiryDate: Date = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        cart.expiryDate = expiryDate;
        this.browser.setLocalStorageValue('$q', cart);

        const form: FormGroup = this.quoteForm.form;
        form.markAsUntouched();

        this.formSubmitted = false;
        this.reCAPTCHA = false;
    }

    submit(): void {
        const form: FormGroup = this.quoteForm.form;
        form.markAllAsTouched();

        if (!this.quoteForm.form.invalid) {
            let rfqProductRequestDto: RfqProductRequestDto = {
                id: 0,
                uid: this.uuid,
                profile: environment.access_profile,
                items: this.state.quoteComponent.data['items'],
                fullName: this.state.contactComponent.data['fullName'],
                emailAddress: this.state.contactComponent.data['emailAddress'],
                mobileNumber: this.state.contactComponent.data['mobileNumber'],
                provinceId: this.state.contactComponent.data['provinceId']
            };

            this.quotationService.newProductRfqRequest(rfqProductRequestDto).subscribe((response: HttpResponseDto): void => {
                this.formSubmitted = true;
                setTimeout((): void => {
                    this.resetForm();
                    this.quoteReceived = true;

                    setTimeout((): void => {
                        this.quoteReceived = false;
                    }, 3000);
                }, 5000);
            }, error => {
                this.formSubmitted = true;
                this.quoteReceived = false;
                console.log(error);
            });
        } else {
            console.log('quoteForm.form invalid');
        }
    }

    onCaptchaResolved(token: string): void {
        this.verifyCaptcha(token);
    }

    verifyCaptcha(token: string): void {
        let httpRequestDto: HttpRequestDto = { data: token };
        this.quotationService.verifyCaptcha(httpRequestDto).subscribe((response: HttpResponseDto): void => {
            console.log('reCAPTCHA v2 Verification Successful. Response: ' + JSON.stringify(response));
            this.reCAPTCHA = true;
        }, error => {
            this.reCAPTCHA = false;
            console.error('Error verifying reCAPTCHA:', error);
        });
    }
}
